// extracted by mini-css-extract-plugin
export default {"panel_content":"login-panel_panel_content__xYcJG","title":"login-panel_title__5gkUb","tip":"login-panel_tip__8+aQV"};